import React from 'react';
import pluralize from 'pluralize';
import { DollarAmount } from 'common/display/Money';
import formatShortDate from 'common/utils/Dates/formatShortDate';
import {
  AUTHORIZATION_STATUSES,
  AUTHORIZATION_STATUSES_TO_ICON,
  AUTHORIZATION_STATUSES_TO_COLOR,
} from 'common/Status/authorizationConstants';

export const formatAmount = (authorization) => {
  const cents = authorization.approved_cents || authorization.requested_cents;
  if (cents) {
    return <DollarAmount value={cents} convertCents />;
  }

  const unitAmount = authorization.approved_unit_amount || authorization.requested_unit_amount;
  if (unitAmount) {
    const unit = authorization.fee_schedule_program?.unit || 'unit';
    const pluralizedUnit = pluralize(unit, unitAmount);
    return `${unitAmount} ${pluralizedUnit}`;
  }

  return 'N/A';
};

export const formatDates = (authorization) => {
  const startsAt = authorization.approved_starts_at || authorization.requested_starts_at;
  const endsAt = authorization.approved_ends_at || authorization.requested_ends_at;

  if (!startsAt && !endsAt) {
    return 'N/A';
  }

  if (startsAt && endsAt) {
    const formattedStartsAt = formatShortDate(startsAt);
    const formattedEndsAt = formatShortDate(endsAt);

    if (formattedStartsAt === formattedEndsAt) {
      return formattedStartsAt;
    }

    return `${formattedStartsAt} - ${formattedEndsAt}`;
  }

  return formatShortDate(startsAt);
};

export const getAuthorizationHistoryIconAttributes = (state) => {
  switch (state) {
    case AUTHORIZATION_STATUSES.rejected:
      return {
        icon: AUTHORIZATION_STATUSES_TO_ICON[AUTHORIZATION_STATUSES.rejected],
        color: AUTHORIZATION_STATUSES_TO_COLOR[AUTHORIZATION_STATUSES.rejected],
      };
    case AUTHORIZATION_STATUSES.accepted:
      return {
        icon: AUTHORIZATION_STATUSES_TO_ICON[AUTHORIZATION_STATUSES.accepted],
        color: AUTHORIZATION_STATUSES_TO_COLOR[AUTHORIZATION_STATUSES.accepted],
      };
    case AUTHORIZATION_STATUSES.void:
      return {
        icon: AUTHORIZATION_STATUSES_TO_ICON[AUTHORIZATION_STATUSES.void],
        color: 'var(--color-text-blue)',
      };
    default:
      return {
        icon: undefined,
        color: undefined,
      };
  }
};
